import { render } from "./builderCreatePost.vue?vue&type=template&id=987e3ffe&scoped=true"
import script from "./builderCreatePost.vue?vue&type=script&lang=js"
export * from "./builderCreatePost.vue?vue&type=script&lang=js"

import "./builderCreatePost.vue?vue&type=style&index=0&id=987e3ffe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987e3ffe"]])

export default __exports__